var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeatherWidgetSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 213 211",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.217 105.5c0-43.662 35.396-79.058 79.058-79.058 43.662 0 79.058 35.396 79.058 79.058 0 43.664-35.396 79.06-79.058 79.06-43.662 0-79.058-35.396-79.058-79.06zm-6.774 11.979-14.266 27.54 28.941 11.155 0.1658 31.015 30.809-3.573 14.562 27.385 25.621-17.482 25.62 17.482 14.56-27.385 30.811 3.573 0.166-31.015 28.941-11.155-14.267-27.54 20.443-23.327-25.429-17.756 7.259-30.154-30.769-3.9045-7.584-30.074-29.06 10.842-20.691-23.104-20.692 23.104-29.06-10.842-7.5838 30.074-30.769 3.9045 7.2585 30.154-25.429 17.756 20.443 23.327z",
    fill: "#F0A64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.27 36.42c38.151 0 69.079 30.928 69.079 69.079 0 38.152-30.928 69.078-69.079 69.078-38.15 0-69.078-30.926-69.078-69.078 0-38.151 30.928-69.079 69.078-69.079z",
    fill: "#F0A64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.33 105.5c0-43.662-35.396-79.058-79.058-79.058v-26.441l20.692 23.104 29.06-10.842 7.584 30.074 30.768 3.9045-7.258 30.154 25.429 17.756-20.443 23.327 14.266 27.54-28.94 11.155-0.166 31.015-30.811-3.573-14.56 27.385-25.621-17.482v-8.959c43.662 0 79.058-35.396 79.058-79.06z",
    fill: "#EB8C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.35 105.5c0 38.152-30.928 69.078-69.079 69.078v-138.16c38.151 0 69.079 30.928 69.079 69.079z",
    fill: "#EB8C3C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherWidgetSun);
export default __webpack_public_path__ + "static/media/weather-widget_sun.31677472.svg";
export { ForwardRef as ReactComponent };